import { IS_SIDEBAR_PANEL_ENABLED } from '@/components/constants/flags';
import { OfflineGatedTooltip } from '@/components/offline-recording/offline-gated-tooltip';
import { useOfflineGating } from '@/hooks/desktop/useOfflineGating';
import { cn } from '@/lib/cn';
import { Button } from '@heidi/design-system/button';
import { RefreshCw } from 'lucide-react';

import { useRefresh } from '@/components/layout/Navigation/sessions/header/toolbar/hooks/useRefresh';

export const RefreshButton = () => {
  const { handleRefresh, isSpinning } = useRefresh();
  const isSidebarPanelEnabled = IS_SIDEBAR_PANEL_ENABLED();
  const { shouldGateControls: isOfflineGated } = useOfflineGating();

  const button = (
    <Button
      data-testid="session-list-refresh-button"
      size="xxs"
      variant={isSidebarPanelEnabled ? 'panel_ghost' : 'ghost'}
      iconOnly
      className={!isSidebarPanelEnabled ? 'text-text-secondary' : undefined}
      onClick={() => void handleRefresh()}
      disabled={isSpinning || isOfflineGated}
      aria-label="Refresh sessions"
    >
      <RefreshCw
        // Keep the icon's own colour online (unchanged appearance); drop it only
        // when gated so the disabled icon dims like its siblings.
        className={cn(
          'size-3',
          !isOfflineGated && !isSidebarPanelEnabled && 'text-text-secondary',
          { 'animate-spin': isSpinning }
        )}
        aria-hidden="true"
      />
    </Button>
  );

  if (!isOfflineGated) return button;

  return <OfflineGatedTooltip isOfflineGated>{button}</OfflineGatedTooltip>;
};
